/**
 * Global scripts regarding Owl Carousel
 */

jQuery(document).ready(function($) {
    // Fix flash of unstyled content in the owl carousel
	$('.carousel-container').addClass('page-loaded');
});
